import { Routes } from '@angular/router';
import { UPUnauthorizedComponent } from 'up';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth.guard';
import { ErrorComponent } from './shared/components/error/error.component';

export const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: UPUnauthorizedComponent,
  },
  {
    path: 'instructor',
    loadChildren: () =>
      import('./instructor/instructor.routes').then((m) => m.instructorRoutes),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'instructor' },
  },
  {
    path: 'ebook',
    loadChildren: () =>
      import('./shared/shared.routes').then((m) => m.sharedRoutes),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'learner' },
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];
